export const MOCK_CLIENT_ID = 1;

export const MOCK_COUNTRY = "BR";

export const MOCK_MV29 = "MV29";
export const MOCK_MV77 = "MV77";
export const MOCK_MV51 = "MV51";
export const MOCK_UARU = "UARU";

export const MOCK_SCE_CODE = "SCE-0000";
export const MOCK_TAG_CODE = "TAG-0000";
export const MOCK_MAH_CODE = "MAH-04b";
export const MOCK_BARRIER_CODE = "BARRIER-0000";
export const MOCK_WO_ID = "000004604860";
export const MOCK_FAMILY_CODE = "MAH23-26-PGD02";
export const MOCK_URL_V2 = "https://shapiworkflow-dev.shapedigital.com/api/v2/";
export const MOCK_URL_V3 = "https://shapiworkflow-dev.shapedigital.com/api/v3/";

export const MOCK_LONG_TEXT =
  "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed at lectus venenatis nulla malesuada consectetur. In in placerat libero. Nam ultrices ligula at dolor vulputate tincidunt. Nulla a nunc id dui elementum efficitur. Fusce ultricies ultricies ultricies. Donec tincidunt justo sit amet dui ullamcorper, ut ornare sapien tristique. Fusce nec quam vitae ligula blandit hendrerit a at tellus. Proin leo dolor, lobortis non interdum a, lobortis eu odio. Nam ultrices id diam non tempor.";

export const MOCK_RECOMMENDATION_ID = 1;

export const funcNotImplemented = () => {
  throw new Error("Function not implemented.");
};
